<script setup lang="ts">
const props = defineProps<{
    type: 'first' | 'second',
    items: {
        title: string,
        groups: string[]
    }
}>();

function handleIsLastIndex(index: number) {
    return index === props.items.groups.length - 1;
};
</script>

<template>
    <div 
        v-for="item, index in props.items.groups" 
        :key="item" 
        class="flex relative gap-2.5 lg:pt-6"
        :class="[
            props.type === 'first' ? 'justify-end lg:ml-20 lg:pl-40' : 'justify-start lg:mr-25 lg:pr-40',
            !handleIsLastIndex(index) && 'pb-14 lg:pb-0',
        ]"
        data-aos="fade-up"
        data-aos-duration="1000"
    >
        <DevicesMobile 
            class="absolute bottom-2 w-1"
            :class="props.type === 'first' ? 'left-2.5' : 'right-2.5'"
        >
            <svg v-if="!handleIsLastIndex(index)" viewBox="0 0 3 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="3" height="32" rx="1.5" fill="#CACFD9"/>
            </svg>
        </DevicesMobile>

        <DevicesDesktop 
            class="absolute bottom-3 w-1 z-[-1]"
            :class="props.type === 'first' ? 'left-2.25 origin-center scale-x-[-1]' : 'right-2.25'"
        >
            <svg width="159" height="82" viewBox="0 0 159 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 79.6998H4.39322C4.42954 79.6998 4.45898 79.7292 4.45898 79.7655C4.45898 79.8019 4.48843 79.8313 4.52475 79.8313H138.09C148.595 79.8313 157.111 71.3151 157.111 60.8098V41.7954C157.111 41.7915 157.114 41.7884 157.118 41.7884C157.122 41.7884 157.125 41.7852 157.125 41.7813V5.75811C157.125 5.75668 157.124 5.75551 157.123 5.75551C157.121 5.75551 157.12 5.75435 157.12 5.75291V1.563C157.12 1.52821 157.092 1.5 157.057 1.5" stroke="#E5E9F0" stroke-width="3" stroke-linecap="round" stroke-linejoin="bevel"/>
            </svg>
        </DevicesDesktop>

        <template v-if="props.type === 'first'">
            <span class="text-gray-400 text-body2-semibold" v-html="item" />
            <Icon 
                name="solar:add-circle-bold" 
                class="text-gray-300 min-w-7 rotate-45" 
                size="28"
            />
        </template>
        <template v-else>
            <Icon 
                name="solar:check-circle-bold" 
                class="text-success-600 min-w-7" 
                size="28" 
            />
            <span class="text-body2-semibold" v-html="item" />
        </template>
    </div>
</template>